import React, {forwardRef} from 'react';
import ModalTemplate from "../../Wrappers/ModalTemplate";
import TabsWrapper from "../../Wrappers/TabsWrapper";
import TabItem from "../../Atoms/TabItem";
import PanelTemplate from "../../Wrappers/PanelTemplate";
import FormInput from "../../Atoms/Templates/FormInput";
import DropContainer from "../../Molecules/DropContainer";
import Checkbox from "../../Atoms/Forms/Checkbox";
import MonthPickerInput from "../../Molecules/Pickers/MonthPickerInput";
import YearPickerInput from "../../Molecules/Pickers/YearPickerInput";

const CompanyInformationModal = forwardRef((props, ref) => {
  return (
    <ModalTemplate
      className="medium"
      ref={ref}
    >
      <TabsWrapper>
        <div className="tabs-container s-main-center s-mb-24px">
          <TabItem index={0}>Información básica</TabItem>
          <TabItem index={1}>Preferencias</TabItem>
        </div>
        <form
          action="#"
          className="s-mb-0">
          <PanelTemplate
            className="ed-grid rows-gap form-grid s-grid-4 l-block"
            index={0}
            onlyHidden
          >
            <FormInput
              isRequired
              label="No. de identificación tributaria"
              placeholder="900 111 222"
              className="s-cols-3"
            />
            <FormInput isDisabled label="DV" placeholder="0" />
            <FormInput
              isRequired
              label="Razón social"
              placeholder="tu empresa"
              className="s-cols-4 m-cols-2"
            />
            <FormInput
              label="Sitio web"
              placeholder="tuweb.com"
              className="s-cols-4 m-cols-2"
            />
            <DropContainer
              id="drop-container-employer"
              label="Logo de la empresa (64 x 64)"
              className="s-cols-4"
            />
          </PanelTemplate>

          <PanelTemplate
            className="ed-grid rows-gap form-grid s-grid-2 l-block"
            index={1}
            onlyHidden
          >
            <div>
              <div className="form-item s-mb-6px">
                <label className="required">Frecuencia de pago</label>
              </div>
              <Checkbox name="biweekly" label="Quincenal" className="s-main-center" />
            </div>

            <Checkbox
              name="monthly"
              label="Mensual"
              className="s-main-center s-cross-end"
            />
            <MonthPickerInput isRequired label="Fecha de inicio para liquidar" />
            <div className="s-cross-end">
              <YearPickerInput isRequired/>
            </div>
          </PanelTemplate>

          <div className="buttons-container">
            <button className="cancel button">Cancelar</button>
            <button className="button">Actualiza la información</button>
          </div>
        </form>
      </TabsWrapper>
    </ModalTemplate>
  );
})

export default CompanyInformationModal;
